import React from "react";

const CopyrightFooterLink = ({ styleClass }: any) => {
	return (
		<div className={styleClass}>
			<span>© 2026 nexcaliber, All rights reserved</span>
		</div>
	);
};

export default CopyrightFooterLink;
